export const dealModalTranslations = {
  en: {
    updateDeal: "Update Deal",
    makeADeal: "Make a Deal",
    makeADealDescription: "Select event from posted opportunities on the market",
    dealWizard: "Deal wizard",
    dealWizardDescription: "Select the contract type template. Each template includes an automatically generated, legally valid PDF, as well as clearly defined timeframes for both parties.",
    modifyExistingDeal: "Modify your existing deal",
    sendDealToGroupMember: "Send deal to group member",
    sendDealToFighter: "Send deal to fighter",
    groupChat: "Group Chat",
    changeFighter: "Change Fighter",
    selectFighter: "Select Fighter",
    updateWhoReceivesDeal: "Update who will receive this deal",
    chooseWhoReceivesDeal: "Choose who will receive this deal",
    noFightersFound: "⚠️ No fighters found in this group. You can only send deals to fighters.",
    chooseFighterPlaceholder: "Choose a fighter from this group",
    sport: "Sport",
    weightClass: "Weight Class",
    level: "Level",
    price: "Price",
    location: "Location",
    dealType: "Deal Type",
    currency: "Currency",
    eventDate: "Event Date",
    attachments: "Attachments",
    clearAll: "Clear All",
    existingAttachments: "Existing Attachments",
    newAttachments: "New Attachments",
    clickOrDragFiles: "Click or drag files to attach",
    fileLimits: "Images (max 20), Videos (max 4, 50MB each), Documents (max 10)",
    fileLimitsWithoutVideo: "Images (max 20), Documents (max 10)",
    dropFilesHere: "Drop files here to attach",
    chooseFile: "Choose file",
    noFileChosen: "No file chosen",
    uploadingFile: "Uploading...",
    viewUploadedFile: "View uploaded file",
    fileSizeLimit: "File size must be {{size}}MB or less",
    unsupportedFileType: "Please upload a supported file type",
    fileUploadFailed: "File upload failed",
    additionalMessage: "Additional Message",
    additionalMessagePlaceholder: "Add any additional details or terms...",
    noOpportunitiesAvailable: "No Opportunities Available",
    createOpportunityCards: "Create some opportunity cards to start making deals.",
    availableOpportunities: "Available Opportunities",
    manager: "Manager",
    sportName: "Sport name",
    prizeMoney: "Prize Money",
    weightClassTooltip: "Weight Class",
    levelTooltip: "Level",
    eventLocation: "Event Location",
    eventDateTooltip: "Event Date",
    status: "Status",
    expired: "Expired",
    published: "Published",
    available: "Available",
    draft: "Draft",
    customizeDeal: "Customize Deal",
    addComponent: "Add component",
    modifyDetailsBeforeSending: "Modify details before sending",
    dealRecipient: "Deal Recipient",
    dealWillBeSentTo: "✅ Deal will be sent to",
    selectFighterFirst: "⚠️ Please select a fighter above to send this deal to",
    missingChatRoomId: "❌ Error: Chat room ID is missing. Cannot send group deal.",
    cancel: "Cancel",
    reset: "Reset",
    sendDeal: "Send Deal",
    updateDealButton: "Update Deal",
    sendingDeal: "Sending Deal...",
    updatingDeal: "Updating Deal...",
    selectFighterFirstButton: "Select Fighter First",
    missingChatRoomIdButton: "Missing Chat Room ID",
    amateur: "Amateur",
    semiPro: "Semi Pro",
    professional: "Professional",
    fight: "Fight",
    sponsorship: "Sponsorship",
    media: "Media",
    contract: "Contract",
    other: "Other",
    viewFile: "View file",
    restoreFile: "Restore file",
    remove: "Remove",
    removeFile: "Remove file",
    removed: "REMOVED",
    coreInformation: "Core Information",
    fightDetails: "Fight Details",
    components: "Components",
    payoutPolicies: "Payout Policies",
    payoutPolicy: {
      coreOutcomes: "Core outcomes",
      customOutcomes: "Custom outcomes",
      baseAmount: "Base amount",
      baseAmountIncluded: "Base amount included",
      baseShort: "Base",
      components: "Components",
      component: "Component",
      included: "Included",
      notSelectable: "Not selectable",
      selectComponents: "Select components",
      addComponentsFirst: "Add components first",
      noPayoutPoliciesConfigured: "No payout policies configured.",
      componentsMustBeApplied: "These components must be applied to at least one payout policy: {{components}}",
      amount: "Amount",
      total: "Total",
    },
    selectComponents: "Select components",
    fundingConfiguration: "Funding Configuration",
    additionalNotes: "Additional Notes",
    componentPaymentsStepTitle: "Component payments",
    componentPaymentsStepDescription: "Set payment dates for each payout component",
    eventDateNoLongerValid: "This date is no longer valid. Please select a new date",
    preMatchDateBetween: "Pre-match date must be between {{min}} and {{max}}",
    postMatchDateBetween: "Post-match date must be between {{min}} and {{max}}",
    preMatchDueDateRequired: "Pre-match due date is required",
    postMatchDueDateRequired: "Post-match due date is required",
    baseAmount: "Base amount",
    noFieldsDefinedForStep: "No fields defined for this step",
    itemsConfigured_one: "{{count}} item configured",
    itemsConfigured_other: "{{count}} items configured",
    noItemsAddedYet: "No items added yet",
    clickAddComponentToStart: "Click \"Add component\" to get started",
    mandatory: "Mandatory",
    paymentDateSubmitFixTitle: "Please fix payment date errors before submitting",
    previous: "Previous",
    next: "Next",
    noPayoutComponentsConfigured: "No payout components configured",
    addComponentsInPreviousStep: "Add components in the previous step",
    preMatchPayments: "Pre-match payments",
    postMatchPayments: "Post-match payments",
    total: "Total",
    paymentDueDate: "Payment due date",
    upToDaysBeforeEvent: "Up to {{days}} days before event",
    upToDaysAfterEvent: "Up to {{days}} days after event",
    percentOfBaseTitle: "{{value}}% of base amount",
    searchFighterByName: "Search fighter by name...",
    loadingFighters: "Loading fighters...",
    noFightersFoundDropdown: "No fighters found",
    useManualValue: "Use \"{{value}}\"",
    fighterNumber: "Fighter #{{id}}",
    loading: "Loading...",
    noResultsFound: "No results found",
    searchCountry: "Search country...",
    selectCountryFirst: "Select a country first",
    searchCity: "Search city...",
    selectPlaceholder: "Select {{label}}",
    minimumValueIs: "Minimum value is {{value}}",
    maximumValueIs: "Maximum value is {{value}}",
    resolvedComponentAmountMinimum: "The resolved component amount must be at least {{amount}}. Increase the value or the base amount.",
    max: "Max {{max}}",
    enterMinutes: "Enter minutes",
    minutes: "minutes",
    errorPreparingEdit: "Error preparing edit",
    dealUpdated: "Deal updated",
    dealSentSuccessfully: "Deal sent successfully",
    requiredField: "{{field}} is required",
    pleaseFillAllRequiredFields: "Please fill all required fields",
    errorOccurred: "An error occurred",
    errorLoadingEventOpportunities: "Failed to load event opportunities",
    errorLoadingOpportunities: "Failed to load opportunities",
    allOpportunities: "All Opportunities",
    eventOpportunities: "Event Opportunities",
    noEventOpportunities: "No Event Opportunities",
    noEventOpportunitiesMessage: "No event opportunities are available.",
    pleaseSignAgreement: "Please sign the agreement",
    componentsInvalid: "Components invalid",
    minValueMustBe: "Minimum value must be {{min}}",
    tooLong: "Too long",
    notAvailableShort: "N/A",
    pageOf: "Page {{page}} of {{total}}",
    attachmentsRemaining: "{{remaining}} of {{total}} files",
    filesCount_one: "{{count}} file",
    filesCount_other: "{{count}} files",
    opponent: "Opponent",
    paymentModeLabel: "Payment Mode",
    dealNotes: "Deal Notes",
    ruleset: "Ruleset",
    country: "Country",
    city: "City",
    venue: "Venue",
    numberOfRounds: "Number of Rounds",
    roundDuration: "Round Duration",
    titleFight: "Title Fight",
    titleDescription: "Title Description",
    medicalSupportProvided: "Medical Support Provided",
    medicalDocument: "Medical Document",
    category: "Category",
    componentType: "Component Type",
    expenseDescription: "Expense Description",
    calculationMode: "Calculation Mode",
    value: "Value",
    fundingStage: "Funding Stage",
    bonusesExpensesPenalties: "Bonuses, Expenses & Penalties",
    bonus: "Bonus",
    expense: "Expense",
    penalty: "Penalty",
    winBonus: "Win bonus",
    performanceBonus: "Performance bonus",
    fightOfTheNight: "Fight of the night",
    performanceOfTheNight: "Performance of the night",
    knockoutOfTheNight: "Knockout of the night",
    submissionOfTheNight: "Submission of the night",
    onWeightBonus: "On-weight bonus",
    mediaPromoBonus: "Media & promo bonus",
    ticketSalesCommission: "Ticket sales commission",
    ppvShareOption: "Ppv share",
    lockerRoomBonus: "Locker room bonus",
    travelExpense: "Travel expense",
    perDiemExpense: "Per diem expense",
    latePenalty: "Late penalty",
    fixedAmount: "Fixed amount",
    percentageOfBaseAmount: "Percentage of base amount",
    preEvent: "Pre event",
    postEvent: "Post event",
    upfront: "Upfront",
    split: "Split",
    documentRequirement: "Document Requirement",
    documentType: "Document Type",
    submissionDeadline: "Submission Deadline",
    additionalNotesOptional: "Additional Notes (optional)",
    uploadStatus: "Upload Status",
    uploadedDocument: "Uploaded Document",
    pendingUpload: "Pending Upload",
    deadlineMissed: "Deadline Missed",
    editAgreementNote: "You changed the deal terms, so a new agreement is created. Your signature will be added to the updated agreement and the fighter will be asked to sign it again.",
    signAgreement: "Sign Agreement",
    agreementSignedSuccessfully: "Agreement signed successfully.",
    finalReviewStepTitle: "Final Review",
    agreementTerms: "By signing you agree to all terms that are listed in this document.",
    contractPdf: "Contract PDF",
    contractNotAvailable: "Contract not available. Go back and press Next again.",
    yourSignature: "Your signature",
    signed: "Signed",
    clear: "Clear",
    signInsideBox: "Sign inside the box using mouse or touch.",
    signAndMakeADeal: "Sign and make a deal",
  },
  de: {
    updateDeal: "Angebot aktualisieren",
    makeADeal: "Ein Angebot machen",
    makeADealDescription: "Wähle ein Event aus den veröffentlichten Möglichkeiten auf dem Markt",
    dealWizard: "Deal-Assistent",
    dealWizardDescription: "Wähle die Vertragsvorlage. Jede Vorlage enthält ein automatisch erstelltes, rechtsgültiges PDF sowie klar definierte Fristen für beide Parteien.",
    modifyExistingDeal: "Ihr bestehendes Angebot ändern",
    sendDealToGroupMember: "Angebot an Gruppenmitglied senden",
    sendDealToFighter: "Angebot an Kämpfer senden",
    groupChat: "Gruppenchat",
    changeFighter: "Kämpfer ändern *",
    selectFighter: "Kämpfer auswählen *",
    updateWhoReceivesDeal: "Aktualisieren, wer dieses Angebot erhält",
    chooseWhoReceivesDeal: "Wählen Sie, wer dieses Angebot erhält",
    noFightersFound: "⚠️ Keine Kämpfer in dieser Gruppe gefunden. Sie können Angebote nur an Kämpfer senden.",
    chooseFighterPlaceholder: "Wählen Sie einen Kämpfer aus dieser Gruppe",
    sport: "Sportart",
    weightClass: "Gewichtsklasse",
    level: "Stufe",
    price: "Preis",
    location: "Ort",
    dealType: "Angebotstyp",
    currency: "Währung",
    eventDate: "Veranstaltungsdatum",
    attachments: "Anhänge",
    clearAll: "Alle löschen",
    existingAttachments: "Vorhandene Anhänge",
    newAttachments: "Neue Anhänge",
    clickOrDragFiles: "Klicken oder Dateien ziehen, um sie anzuhängen",
    fileLimits: "Bilder (max. 20), Videos (max. 4, je 50 MB), Dokumente (max. 10)",
    fileLimitsWithoutVideo: "Bilder (max. 20), Dokumente (max. 10)",
    dropFilesHere: "Dateien hier ablegen, um sie anzuhängen",
    additionalMessage: "Zusätzliche Nachricht",
    additionalMessagePlaceholder: "Fügen Sie weitere Details oder Bedingungen hinzu...",
    noOpportunitiesAvailable: "Keine Möglichkeiten verfügbar",
    createOpportunityCards: "Erstellen Sie einige Möglichkeitskarten, um mit Angeboten zu beginnen.",
    availableOpportunities: "Verfügbare Möglichkeiten",
    manager: "Manager",
    sportName: "Sportartname",
    prizeMoney: "Preisgeld",
    weightClassTooltip: "Gewichtsklasse",
    levelTooltip: "Stufe",
    eventLocation: "Veranstaltungsort",
    eventDateTooltip: "Veranstaltungsdatum",
    status: "Status",
    expired: "Abgelaufen",
    published: "Veröffentlicht",
    available: "Verfügbar",
    draft: "Entwurf",
    customizeDeal: "Angebot anpassen",
    addComponent: "Komponente hinzufügen",
    modifyDetailsBeforeSending: "Details vor dem Senden ändern",
    dealRecipient: "Angebotsempfänger",
    dealWillBeSentTo: "✅ Angebot wird gesendet an",
    selectFighterFirst: "⚠️ Bitte wählen Sie oben einen Kämpfer aus, um dieses Angebot zu senden",
    missingChatRoomId: "❌ Fehler: Chatraum-ID fehlt. Gruppenangebot kann nicht gesendet werden.",
    cancel: "Abbrechen",
    reset: "Zurücksetzen",
    sendDeal: "Angebot senden",
    updateDealButton: "Angebot aktualisieren",
    sendingDeal: "Angebot wird gesendet...",
    updatingDeal: "Angebot wird aktualisiert...",
    selectFighterFirstButton: "Zuerst Kämpfer auswählen",
    missingChatRoomIdButton: "Fehlende Chatraum-ID",
    amateur: "Amateur",
    semiPro: "Halbprofi",
    professional: "Profi",
    fight: "Kampf",
    sponsorship: "Sponsoring",
    media: "Medien",
    contract: "Vertrag",
    other: "Andere",
    viewFile: "Datei ansehen",
    restoreFile: "Datei wiederherstellen",
    remove: "Entfernen",
    removeFile: "Datei entfernen",
    removed: "ENTFERNT",
    coreInformation: "Kerninformationen",
    fightDetails: "Kampfdaten",
    components: "Komponenten",
    payoutPolicies: "Auszahlungsregeln",
    payoutPolicy: {
      coreOutcomes: "Kern-Ergebnisse",
      customOutcomes: "Benutzerdefinierte Ergebnisse",
      baseAmount: "Basisbetrag",
      baseAmountIncluded: "Basisbetrag enthalten",
      baseShort: "Basis",
      components: "Komponenten",
      component: "Komponente",
      included: "Enthalten",
      notSelectable: "Nicht auswählbar",
      selectComponents: "Komponenten auswählen",
      addComponentsFirst: "Fügen Sie zuerst Komponenten hinzu",
      noPayoutPoliciesConfigured: "Keine Auszahlungsregeln konfiguriert.",
      componentsMustBeApplied: "Diese Komponenten müssen mindestens einer Auszahlungsrichtlinie zugewiesen werden: {{components}}",
      amount: "Betrag",
      total: "Gesamt",
    },
    selectComponents: "Komponenten auswählen",
    fundingConfiguration: "Finanzierungskonfiguration",
    additionalNotes: "Zusätzliche Notizen",
    componentPaymentsStepTitle: "Komponentenzahlungen",
    componentPaymentsStepDescription: "Legen Sie Zahlungsdaten für jede Auszahlungskomponente fest",
    eventDateNoLongerValid: "Dieses Datum ist nicht mehr gültig. Bitte wählen Sie ein neues Datum",
    preMatchDateBetween: "Das Datum vor dem Kampf muss zwischen {{min}} und {{max}} liegen",
    postMatchDateBetween: "Das Datum nach dem Kampf muss zwischen {{min}} und {{max}} liegen",
    preMatchDueDateRequired: "Fälligkeitsdatum vor dem Kampf ist erforderlich",
    postMatchDueDateRequired: "Fälligkeitsdatum nach dem Kampf ist erforderlich",
    baseAmount: "Basisbetrag",
    noFieldsDefinedForStep: "Für diesen Schritt sind keine Felder definiert",
    itemsConfigured_one: "{{count}} Element konfiguriert",
    itemsConfigured_other: "{{count}} Elemente konfiguriert",
    noItemsAddedYet: "Noch keine Elemente hinzugefügt",
    clickAddComponentToStart: "Klicken Sie auf \"Komponente hinzufügen\", um zu beginnen",
    mandatory: "Obligatorisch",
    paymentDateSubmitFixTitle: "Bitte beheben Sie die Fehler bei den Zahlungsdaten vor dem Absenden",
    previous: "Zurück",
    next: "Weiter",
    noPayoutComponentsConfigured: "Keine Auszahlungskomponenten konfiguriert",
    addComponentsInPreviousStep: "Fügen Sie Komponenten im vorherigen Schritt hinzu",
    preMatchPayments: "Zahlungen vor dem Kampf",
    postMatchPayments: "Zahlungen nach dem Kampf",
    total: "Gesamt",
    paymentDueDate: "Fälligkeitsdatum der Zahlung",
    upToDaysBeforeEvent: "Bis zu {{days}} Tage vor dem Event",
    upToDaysAfterEvent: "Bis zu {{days}} Tage nach dem Event",
    percentOfBaseTitle: "{{value}}% des Basisbetrags",
    searchFighterByName: "Kämpfer nach Namen suchen...",
    loadingFighters: "Kämpfer werden geladen...",
    noFightersFoundDropdown: "Keine Kämpfer gefunden",
    useManualValue: "\"{{value}}\" verwenden",
    fighterNumber: "Kämpfer #{{id}}",
    loading: "Laden...",
    noResultsFound: "Keine Ergebnisse gefunden",
    searchCountry: "Land suchen...",
    selectCountryFirst: "Wählen Sie zuerst ein Land aus",
    searchCity: "Stadt suchen...",
    selectPlaceholder: "{{label}} auswählen",
    minimumValueIs: "Mindestwert ist {{value}}",
    maximumValueIs: "Höchstwert ist {{value}}",
    resolvedComponentAmountMinimum: "Der berechnete Komponentenbetrag muss mindestens {{amount}} betragen. Erhöhen Sie den Wert oder den Basisbetrag.",
    max: "Max. {{max}}",
    enterMinutes: "Minuten eingeben",
    minutes: "Minuten",
    errorPreparingEdit: "Fehler beim Vorbereiten der Bearbeitung",
    dealUpdated: "Deal aktualisiert",
    dealSentSuccessfully: "Deal erfolgreich gesendet",
    requiredField: "{{field}} ist erforderlich",
    pleaseFillAllRequiredFields: "Bitte füllen Sie alle Pflichtfelder aus",
    errorOccurred: "Ein Fehler ist aufgetreten",
    errorLoadingEventOpportunities: "Fehler beim Laden der Event-Möglichkeiten",
    errorLoadingOpportunities: "Fehler beim Laden der Möglichkeiten",
    allOpportunities: "Alle Möglichkeiten",
    eventOpportunities: "Event-Möglichkeiten",
    noEventOpportunities: "Keine Event-Möglichkeiten",
    noEventOpportunitiesMessage: "Es sind keine Event-Möglichkeiten verfügbar.",
    pleaseSignAgreement: "Bitte unterzeichnen Sie die Vereinbarung",
    componentsInvalid: "Komponenten ungültig",
    minValueMustBe: "Mindestwert muss {{min}} sein",
    tooLong: "Zu lang",
    notAvailableShort: "N/V",
    pageOf: "Seite {{page}} von {{total}}",
    attachmentsRemaining: "{{remaining}} von {{total}} Dateien",
    filesCount_one: "{{count}} Datei",
    filesCount_other: "{{count}} Dateien",
    opponent: "Gegner",
    paymentModeLabel: "Zahlungsart",
    dealNotes: "Angebotsnotizen",
    ruleset: "Regelwerk",
    country: "Land",
    city: "Stadt",
    venue: "Austragungsort",
    numberOfRounds: "Anzahl der Runden",
    roundDuration: "Rundendauer",
    titleFight: "Titelkampf",
    titleDescription: "Titelbeschreibung",
    medicalSupportProvided: "Medizinische Unterstützung vorhanden",
    medicalDocument: "Medizinisches Dokument",
    category: "Kategorie",
    componentType: "Komponententyp",
    expenseDescription: "Ausgabenbeschreibung",
    calculationMode: "Berechnungsmodus",
    value: "Wert",
    fundingStage: "Finanzierungsphase",
    bonusesExpensesPenalties: "Boni, Ausgaben & Strafen",
    bonus: "Bonus",
    expense: "Ausgabe",
    penalty: "Strafe",
    winBonus: "Siegbonus",
    performanceBonus: "Leistungsbonus",
    fightOfTheNight: "Kampf der Nacht",
    performanceOfTheNight: "Leistung der Nacht",
    knockoutOfTheNight: "Knockout der Nacht",
    submissionOfTheNight: "Aufgabe der Nacht",
    onWeightBonus: "Gewichtsbonus",
    mediaPromoBonus: "Medien- & Promo-Bonus",
    ticketSalesCommission: "Ticketverkaufsprovision",
    ppvShareOption: "PPV-Anteil",
    lockerRoomBonus: "Umkleidebonus",
    travelExpense: "Reisekosten",
    perDiemExpense: "Tagegeld",
    latePenalty: "Verspätungsstrafe",
    fixedAmount: "Festbetrag",
    percentageOfBaseAmount: "Prozentsatz des Basisbetrags",
    preEvent: "Vor der Veranstaltung",
    postEvent: "Nach der Veranstaltung",
    upfront: "Im Voraus",
    split: "Aufgeteilt",
    documentRequirement: "Dokumentenanforderung",
    documentType: "Dokumententyp",
    submissionDeadline: "Einreichungsfrist",
    additionalNotesOptional: "Zusätzliche Hinweise (optional)",
    uploadStatus: "Upload-Status",
    uploadedDocument: "Hochgeladenes Dokument",
    pendingUpload: "Upload ausstehend",
    deadlineMissed: "Frist verpasst",
    editAgreementNote: "Sie haben die Deal-Bedingungen geändert, daher wird ein neues Abkommen erstellt. Ihre Unterschrift wird dem aktualisierten Abkommen hinzugefügt und der Kämpfer wird gebeten, es erneut zu unterzeichnen.",
    signAgreement: "Vereinbarung unterzeichnen",
    agreementSignedSuccessfully: "Vereinbarung erfolgreich unterzeichnet.",
    finalReviewStepTitle: "Abschließende Überprüfung",
    agreementTerms: "Durch die Unterschrift erklären Sie sich mit allen in diesem Dokument aufgeführten Bedingungen einverstanden.",
    contractPdf: "Vertrags-PDF",
    contractNotAvailable: "Vertrag nicht verfügbar. Gehen Sie zurück und drücken Sie erneut auf Weiter.",
    yourSignature: "Ihre Unterschrift",
    signed: "Unterzeichnet",
    clear: "Löschen",
    signInsideBox: "Unterschreiben Sie im Feld mit der Maus oder dem Touchscreen.",
    signAndMakeADeal: "Unterschreiben und Deal abschließen",
  },
  hr: {
    updateDeal: "Ažuriraj ponudu",
    makeADeal: "Sklopi posao",
    makeADealDescription: "Odaberite događaj iz objavljenih prilika na tržištu",
    dealWizard: "Čarobnjak za posao",
    dealWizardDescription: "Odaberite predložak ugovora. Svaki predložak uključuje automatski generiran, pravno valjan PDF te jasno definirane rokove za obje strane.",
    modifyExistingDeal: "Izmijenite svoju postojeću ponudu",
    sendDealToGroupMember: "Pošalji ponudu članu grupe",
    sendDealToFighter: "Pošalji ponudu borcu",
    groupChat: "Grupni razgovor",
    changeFighter: "Promijeni borca *",
    selectFighter: "Odaberi borca *",
    updateWhoReceivesDeal: "Ažuriraj tko će primiti ovu ponudu",
    chooseWhoReceivesDeal: "Odaberi tko će primiti ovu ponudu",
    noFightersFound: "⚠️ Nema pronađenih boraca u ovoj grupi. Ponude možete slati samo borcima.",
    chooseFighterPlaceholder: "Odaberi borca iz ove grupe",
    sport: "Vrsta sporta",
    weightClass: "Težinska kategorija",
    level: "Razina",
    price: "Cijena",
    location: "Lokacija",
    dealType: "Vrsta ponude",
    currency: "Valuta",
    eventDate: "Datum događaja",
    attachments: "Prilozi",
    clearAll: "Obriši sve",
    existingAttachments: "Postojeći prilozi",
    newAttachments: "Novi prilozi",
    clickOrDragFiles: "Klikni ili povuci datoteke za prilaganje",
    fileLimits: "Slike (maks. 20), Videozapisi (maks. 4, svaki 50 MB), Dokumenti (maks. 10)",
    fileLimitsWithoutVideo: "Slike (maks. 20), Dokumenti (maks. 10)",
    dropFilesHere: "Spusti datoteke ovdje za prilaganje",
    additionalMessage: "Dodatna poruka",
    additionalMessagePlaceholder: "Dodaj dodatne detalje ili uvjete...",
    noOpportunitiesAvailable: "Nema dostupnih prilika",
    createOpportunityCards: "Stvorite neke kartice prilika kako biste započeli s ponudama.",
    availableOpportunities: "Dostupne prilike",
    manager: "Menadžer",
    sportName: "Naziv sporta",
    prizeMoney: "Novčana nagrada",
    weightClassTooltip: "Težinska kategorija",
    levelTooltip: "Razina",
    eventLocation: "Mjesto događaja",
    eventDateTooltip: "Datum događaja",
    status: "Status",
    expired: "Isteklo",
    published: "Objavljeno",
    available: "Dostupno",
    draft: "Nacrt",
    customizeDeal: "Prilagodi ponudu",
    addComponent: "Dodaj komponentu",
    modifyDetailsBeforeSending: "Izmijenite detalje prije slanja",
    dealRecipient: "Primatelj ponude",
    dealWillBeSentTo: "✅ Ponuda će biti poslana",
    selectFighterFirst: "⚠️ Molimo odaberite borca iznad kako biste poslali ovu ponudu",
    missingChatRoomId: "❌ Pogreška: Nedostaje ID sobe za razgovor. Grupna ponuda se ne može poslati.",
    cancel: "Otkaži",
    reset: "Poništi",
    sendDeal: "Pošalji ponudu",
    updateDealButton: "Ažuriraj ponudu",
    sendingDeal: "Slanje ponude...",
    updatingDeal: "Ažuriranje ponude...",
    selectFighterFirstButton: "Prvo odaberi borca",
    missingChatRoomIdButton: "Nedostaje ID sobe za razgovor",
    amateur: "Amater",
    semiPro: "Poluprofesionalac",
    professional: "Profesionalac",
    fight: "Borba",
    sponsorship: "Sponzorstvo",
    media: "Mediji",
    contract: "Ugovor",
    other: "Ostalo",
    viewFile: "Pogledaj datoteku",
    restoreFile: "Vrati datoteku",
    remove: "Ukloni",
    removeFile: "Ukloni datoteku",
    removed: "UKLONJENO",
    coreInformation: "Osnovne informacije",
    fightDetails: "Detalji borbe",
    components: "Komponente",
    payoutPolicies: "Pravila isplate",
    payoutPolicy: {
      coreOutcomes: "Osnovni ishodi",
      customOutcomes: "Prilagođeni ishodi",
      baseAmount: "Osnovni iznos",
      baseAmountIncluded: "Osnovni iznos uključen",
      baseShort: "Osnovica",
      components: "Komponente",
      component: "Komponenta",
      included: "Uključeno",
      notSelectable: "Nije moguće odabrati",
      selectComponents: "Odaberite komponente",
      addComponentsFirst: "Prvo dodajte komponente",
      noPayoutPoliciesConfigured: "Nema konfiguriranih pravila isplate.",
      componentsMustBeApplied: "Ove komponente moraju se primijeniti na barem jednu politiku isplate: {{components}}",
      amount: "Iznos",
      total: "Ukupno",
    },
    selectComponents: "Odaberite komponente",
    fundingConfiguration: "Konfiguracija financiranja",
    additionalNotes: "Dodatne bilješke",
    componentPaymentsStepTitle: "Plaćanja komponenti",
    componentPaymentsStepDescription: "Postavite datume plaćanja za svaku komponentu isplate",
    eventDateNoLongerValid: "Ovaj datum više nije valjan. Odaberite novi datum",
    preMatchDateBetween: "Datum prije meča mora biti između {{min}} i {{max}}",
    postMatchDateBetween: "Datum nakon meča mora biti između {{min}} i {{max}}",
    preMatchDueDateRequired: "Datum dospijeća prije meča je obavezan",
    postMatchDueDateRequired: "Datum dospijeća nakon meča je obavezan",
    baseAmount: "Osnovni iznos",
    noFieldsDefinedForStep: "Za ovaj korak nisu definirana polja",
    itemsConfigured_one: "{{count}} stavka konfigurirana",
    itemsConfigured_other: "{{count}} stavki konfigurirano",
    noItemsAddedYet: "Još nema dodanih stavki",
    clickAddComponentToStart: "Kliknite \"Dodaj komponentu\" za početak",
    mandatory: "Obavezno",
    paymentDateSubmitFixTitle: "Ispravite pogreške datuma plaćanja prije slanja",
    previous: "Natrag",
    next: "Dalje",
    noPayoutComponentsConfigured: "Nema konfiguriranih komponenti isplate",
    addComponentsInPreviousStep: "Dodajte komponente u prethodnom koraku",
    preMatchPayments: "Plaćanja prije meča",
    postMatchPayments: "Plaćanja nakon meča",
    total: "Ukupno",
    paymentDueDate: "Datum dospijeća plaćanja",
    upToDaysBeforeEvent: "Do {{days}} dana prije događaja",
    upToDaysAfterEvent: "Do {{days}} dana nakon događaja",
    percentOfBaseTitle: "{{value}}% osnovnog iznosa",
    searchFighterByName: "Pretraži borca po imenu...",
    loadingFighters: "Učitavanje boraca...",
    noFightersFoundDropdown: "Nema pronađenih boraca",
    useManualValue: "Koristi \"{{value}}\"",
    fighterNumber: "Borac #{{id}}",
    loading: "Učitavanje...",
    noResultsFound: "Nema rezultata",
    searchCountry: "Pretraži državu...",
    selectCountryFirst: "Prvo odaberite državu",
    searchCity: "Pretraži grad...",
    selectPlaceholder: "Odaberi {{label}}",
    minimumValueIs: "Minimalna vrijednost je {{value}}",
    maximumValueIs: "Maksimalna vrijednost je {{value}}",
    resolvedComponentAmountMinimum: "Izračunati iznos komponente mora biti najmanje {{amount}}. Povećajte vrijednost ili osnovni iznos.",
    max: "Maks. {{max}}",
    enterMinutes: "Unesite minute",
    minutes: "minute",
    errorPreparingEdit: "Pogreška pri pripremi uređivanja",
    dealUpdated: "Dogovor ažuriran",
    dealSentSuccessfully: "Dogovor uspješno poslan",
    requiredField: "{{field}} je obavezno",
    pleaseFillAllRequiredFields: "Molimo popunite sva obavezna polja",
    errorOccurred: "Došlo je do pogreške",
    errorLoadingEventOpportunities: "Došlo je do pogreške pri učitavanju prilika događaja",
    errorLoadingOpportunities: "Došlo je do pogreške pri učitavanju prilika",
    allOpportunities: "Sve prilike",
    eventOpportunities: "Prilike događaja",
    noEventOpportunities: "Nema prilika događaja",
    noEventOpportunitiesMessage: "Nema dostupnih prilika događaja.",
    pleaseSignAgreement: "Molimo potpišite ugovor",
    componentsInvalid: "Komponente nisu valjane",
    minValueMustBe: "Minimalna vrijednost mora biti {{min}}",
    tooLong: "Predugo",
    notAvailableShort: "N/D",
    pageOf: "Stranica {{page}} od {{total}}",
    attachmentsRemaining: "{{remaining}} od {{total}} datoteka",
    filesCount_one: "{{count}} datoteka",
    filesCount_other: "{{count}} datoteka",
    opponent: "Protivnik",
    paymentModeLabel: "Način plaćanja",
    dealNotes: "Napomene o ponudi",
    ruleset: "Pravilnik",
    country: "Država",
    city: "Grad",
    venue: "Mjesto održavanja",
    numberOfRounds: "Broj rundi",
    roundDuration: "Trajanje runde",
    titleFight: "Borba za titulu",
    titleDescription: "Opis titule",
    medicalSupportProvided: "Osigurana medicinska podrška",
    medicalDocument: "Medicinski dokument",
    category: "Kategorija",
    componentType: "Vrsta komponente",
    expenseDescription: "Opis troška",
    calculationMode: "Način izračuna",
    value: "Vrijednost",
    fundingStage: "Faza financiranja",
    bonusesExpensesPenalties: "Bonusi, troškovi i kazne",
    bonus: "Bonus",
    expense: "Trošak",
    penalty: "Kazna",
    winBonus: "Bonus za pobjedu",
    performanceBonus: "Bonus za učinak",
    fightOfTheNight: "Borba večeri",
    performanceOfTheNight: "Nastup večeri",
    knockoutOfTheNight: "Nokaut večeri",
    submissionOfTheNight: "Predaja večeri",
    onWeightBonus: "Bonus za postignutu težinu",
    mediaPromoBonus: "Bonus za medije i promociju",
    ticketSalesCommission: "Provizija od prodaje ulaznica",
    ppvShareOption: "PPV udio",
    lockerRoomBonus: "Bonus za svlačionicu",
    travelExpense: "Putni troškovi",
    perDiemExpense: "Dnevnica",
    latePenalty: "Kazna za kašnjenje",
    fixedAmount: "Fiksni iznos",
    percentageOfBaseAmount: "Postotak osnovnog iznosa",
    preEvent: "Prije događaja",
    postEvent: "Nakon događaja",
    upfront: "Unaprijed",
    split: "Podijeljeno",
    documentRequirement: "Zahtjev za dokument",
    documentType: "Vrsta dokumenta",
    submissionDeadline: "Rok za predaju",
    additionalNotesOptional: "Dodatne napomene (neobavezno)",
    uploadStatus: "Status učitavanja",
    uploadedDocument: "Učitani dokument",
    pendingUpload: "Čeka učitavanje",
    deadlineMissed: "Rok propušten",
    editAgreementNote: "Promijenili ste uvjete dogovora, stoga se kreira novi ugovor. Vaš potpis će biti dodan ažuriranom ugovoru i borac će biti zamoljen da ga potpiše ponovo.",
    signAgreement: "Potpiši ugovor",
    agreementSignedSuccessfully: "Ugovor je uspješno potpisan.",
    finalReviewStepTitle: "Konačni pregled",
    agreementTerms: "Potpisom pristajete na sve uvjete navedene u ovom dokumentu.",
    contractPdf: "Ugovor PDF",
    contractNotAvailable: "Ugovor nije dostupan. Vratite se i ponovno pritisnite Dalje.",
    yourSignature: "Vaš potpis",
    signed: "Potpisano",
    clear: "Obriši",
    signInsideBox: "Potpišite unutar okvira pomoću miša ili dodirnog ekrana.",
    signAndMakeADeal: "Potpiši i ugovori se",
  },
}; 